<ng-container *ngIf="!isMobile">
  <div class="pos-header">
    <div class="logo d-flex align-items-center">
      <a (click)="reload(); $event.preventDefault()">
        <img src="./assets/img/duck-pos-dark.png" style="height: 25px;">
      </a>
      <span class="ms-2 text-gray-500">v{{version}}</span>
    </div>
    <div class="nav w-100">
      <div class="nav-item">
        <a routerLink="/" class="text-decoration-none fs-6 nav-link">
          <div class="d-flex flex-column align-items-center ">
            <i class="fa fa-star text-yellow-400"></i>
            <span>New Sales</span>
          </div>
        </a>
      </div>
      <div class="nav-item">
        <a routerLink="/expenses-list" class="text-decoration-none fs-6 nav-link">
          <div class="d-flex flex-column align-items-center ">
            <i class="fa fa-money-bill text-yellow-400"></i>
            <span>Cash In Out</span>
          </div>
        </a>
      </div>
      <div class="nav-item" *ngIf="isWastageEnabled">
        <a routerLink="/wastage-list" class="text-decoration-none fs-6 nav-link">
          <div class="d-flex flex-column align-items-center ">
            <i class="fa fa-recycle text-yellow-400"></i>
            <span>Wastage</span>
          </div>
        </a>
      </div>
      <div class="nav-item">
        <a routerLink="/payment-list" class="text-decoration-none fs-6 nav-link">
          <div class="d-flex flex-column align-items-center ">
            <i class="fa fa-history text-yellow-400"></i>
            <span>Sales History</span>
          </div>
        </a>
      </div>
      <div class="nav-item" *ngIf="this.isShow == true">
        <a routerLink="/attendance-list" class="text-decoration-none fs-6 nav-link">
          <div class="d-flex flex-column align-items-center ">
            <i class="fa fa-user-clock text-yellow-400"></i>
            <span>Clock In Out</span>
          </div>
        </a>
      </div>

      <div class="nav-item" *ngIf="user.role == 'cashier' && this.merchant.printingHost">
        <a (click)="printerConfig()" class="text-decoration-none fs-6 nav-link">
          <div class="d-flex flex-column align-items-center ">
            <i class="fa-solid fa-gear text-yellow-400"></i>
            <span>Setting</span>
          </div>
        </a>
      </div>

      <!--    <div class="nav-item">-->
      <!--      <a routerLink="/stock" class="text-decoration-none fs-6 nav-link">-->
      <!--        <div class="d-flex flex-column align-items-center ">-->
      <!--          <i class="fa fa-history text-yellow-400"></i>-->
      <!--          <span>Stock Adjustment</span>-->
      <!--        </div>-->
      <!--      </a>-->
      <!--    </div>-->
      <!--    <div class="nav-item">-->
      <!--      <a href="" (click)="kickCashDrawer();$event.preventDefault(); " class="text-decoration-none fs-6 nav-link">-->
      <!--        <div class="d-flex flex-column align-items-center ">-->
      <!--          <i class="fa fa-cash-register text-yellow-400"></i>-->
      <!--          <span>Cash Drawer</span>-->
      <!--        </div>-->
      <!--      </a>-->
      <!--    </div>-->
      <div class="nav-item">
        <a routerLink="/user-profile" class="nav-link">
          <div class="d-flex justify-content-between align-items-center">
            <div style="height: 40px; width: 40px; border-radius: 50%; border: 1px yellow solid"
                 class="d-flex justify-content-center align-items-center me-2">
              <img
                *ngIf="merchant?.merchantLogo"
                [ngStyle]="{'background-image': 'url(' +merchant?.['merchantLogoSmall']+')'}" class="w-100 h-100"
                style="border-radius: 50%; background-size: cover; background-repeat: no-repeat; background-position: center" />
              <span *ngIf="!merchant?.['merchantLogoSmall']">{{user?.username | slice:0:2 | uppercase}}</span>
            </div>
            <span>{{user?.username}} <br>
            <span class="small float-end" style="color: #fcd609; font-size: 11px; text-align: right">{{user.role | titlecase}}</span></span>
          </div>
        </a>
      </div>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="isMobile">
  <div class="pos-header">
    <div class="logo d-flex align-items-center">
      <a (click)="reload(); $event.preventDefault()">
        <img src="./assets/img/duck-pos-dark.png" style="height: 25px;">
      </a>
      <span class="ms-2 text-gray-500">v{{version}}</span>
    </div>
    <div class="nav w-100">
      <div class="nav-item">
        <a class="nav-link" [matMenuTriggerFor]="menu">
          <div class="d-flex justify-content-between align-items-center">
            <div style="height: 40px; width: 40px; border-radius: 50%; border: 1px yellow solid"
                 class="d-flex justify-content-center align-items-center">
              <img
                *ngIf="merchant?.merchantLogo"
                [ngStyle]="{'background-image': 'url(' +merchant?.['merchantLogoSmall']+')'}" class="w-100 h-100"
                style="border-radius: 50%; background-size: cover; background-repeat: no-repeat; background-position: center" />
              <span *ngIf="!merchant?.['merchantLogoSmall']">{{user?.username | slice:0:2 | uppercase}}</span>
            </div>
<!--            <span>{{user?.username}} <br>-->
<!--            <span class="small float-end" style="color: #fcd609; font-size: 11px; text-align: right">{{user.role | titlecase}}</span></span>-->
          </div>
        </a>
      </div>

      <mat-menu #menu="matMenu" yPosition="below">
        <button mat-menu-item>
          <i class="fa-solid fa-user text-muted-700 me-2"></i>
          <span class="text-muted-700">{{user?.username}}</span><br>
          <span class="small float-end" style="color: #fcd609; font-size: 11px; text-align: right">{{user.role | titlecase}}</span>
        </button>

        <button mat-menu-item routerLink="/">
          <i class="fa fa-star text-yellow-400 me-2"></i>
          <span class="text-black">New Sales</span>
        </button>
        <button mat-menu-item routerLink="/expenses-list">
          <i class="fa fa-money-bill text-yellow-400 me-2"></i>
          <span class="text-black">Cash In Out</span>
        </button>
        <button mat-menu-item routerLink="/wastage-list" *ngIf="isWastageEnabled">
          <i class="fa fa-recycle text-yellow-400 me-2"></i>
          <span class="text-black">Wastage</span>
        </button>
        <button mat-menu-item routerLink="/payment-list">
          <i class="fa fa-history text-yellow-400 me-2"></i>
          <span class="text-black">Sales History</span>
        </button>

        <button mat-menu-item *ngIf="user.role == 'cashier' && this.merchant.printingHost" (click)="printerConfig()">
          <i class="fa-solid fa-gear text-yellow-400 me-2"></i>
          <span class="text-black">Setting</span>
        </button>
        <button mat-menu-item routerLink="/user-profile">
          <i class="fa-solid fa-right-from-bracket text-yellow-400 me-2"></i>
          <span class="text-black">End Shift</span>
        </button>
      </mat-menu>
    </div>
  </div>
</ng-container>
